// extracted by mini-css-extract-plugin
export var expandedRowWrapper = "_57-6";
export var headerCell = "_57-2";
export var rowWrapper = "_57-4";
export var stickyAggregationCell = "_57-a";
export var stickyAggregationRow = "_57-7";
export var stickyColumnCell = "_57-9";
export var stickyColumnHeaderCell = "_57-8";
export var table = "_57-1";
export var virtualRowWrapper = "_57-5";
export var virtualTableContainer = "_57-0";
export var white = "_57-3";